import { useAppSelector } from 'store/hooks'

import { AuthStatus } from '../redux/authSlice'

// isAuth() true если пользователь зарегистрирован ввел все данные
export const useIsAuth = () => {
  const authStatus = useAppSelector(state => state.auth.authInfo.status)
  return authStatus === AuthStatus.registered
}
